module.exports = __webpack_public_path__ + "static/media/Pic.0567b137.png";